export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.018 15.955a.108.108 0 01-.012-.096l4.197-11.79A.101.101 0 0111.298 4h1.404c.042 0 .08.027.095.068l4.197 11.791a.108.108 0 01-.012.096.1.1 0 01-.083.045h-1.491a.101.101 0 01-.095-.07l-1.12-3.305H9.807l-1.12 3.305a.101.101 0 01-.095.07H7.101a.1.1 0 01-.083-.045zM12 6.138l-1.704 5.028h3.408L12 6.138zM3.25 19a.75.75 0 01.75-.75h16a.75.75 0 010 1.5H4a.75.75 0 01-.75-.75z\" fill=\"#6F7488\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};